import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { HOME_URL } from '../const/URL.const';
import { useAuthenticationContext } from '../yoello-lib/modules/auth/AuthenticationContext';
import { resetUsersVenues, resetVenuePermissions, setVenueMerchant } from '../yoello-lib/modules/redux/actions/venue.actions';

export function useUserLogout() {
  const { userLogout } = useAuthenticationContext();
  const history = useHistory();
  const dispatch = useDispatch();

  function logout(){
     userLogout().then(async()=>{
      history.push(HOME_URL+history.location.search);
     }).then(()=>{
      dispatch(setVenueMerchant(undefined));
      //remove all venues and permissions when user loggd out
      dispatch(resetUsersVenues());
     }).finally(()=>{
      dispatch(resetVenuePermissions())
     });
  }
  return {
    logout
  }
}
